import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import Slider from "common/Slider"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    text-align: center;
    margin: 20px 0;
  `,
  Items: styled.div`
    margin-top: 20px;
    padding-bottom: 30px;
    background-color: ${(p) => p.theme.colors.whiteTwo};
  `,
  Section: styled.div`
    margin: 0 27px;
  `,
  Item: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Title: styled(Typography)`
    margin-top: 16px;
    font-size: 20px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
  `,
  Description: styled(Typography)`
    margin-top: 7px;
    font-size: 14px;
    color: ${(p) => p.theme.colors.marine};
  `,
}

type VehicleGalleryMobileProps = {
  data: api.VehicleOutInOptionsGallery[]
  type: string
}

const VehicleGalleryMobile = ({ data, type }: VehicleGalleryMobileProps) => {
  return (
    <Styled.Wrapper>
      <Shared.Header>מאפייני {type}</Shared.Header>
      <Shared.Divider />
      <Styled.Items>
        <Slider
          prefix="galleries"
          loop
          data={data}
          spaceBetween={5}
          renderSection={(item) => (
            <Styled.Section>
              <Styled.Title>{item.name}</Styled.Title>
              <Styled.Description>{item.description}</Styled.Description>
            </Styled.Section>
          )}
          render={(item) => (
            <Styled.Item>
              <RatioElement ratio={3 / 2}>
                <ResponsiveModelImage
                  image={item.image}
                  cover
                  imageSizes="82vw"
                />
              </RatioElement>
            </Styled.Item>
          )}
        />
      </Styled.Items>
    </Styled.Wrapper>
  )
}

export default memo(VehicleGalleryMobile)
